import { useScopedOrganizationId } from "@/contexts/WorkspaceOrgContext";
import { FIREFLY_TARGET_ATTR } from "@/lib/firefly/fireflyTargetConvention";
import { cardMutedTextClass, sectionCardClass } from "@/components/common/surfaceClasses";
import { RoleplayTrainingSection } from "@/components/training-author/RoleplayTrainingSection";

/**
 * Workspace mode: Manager-bucket Training Authoring surface.
 *
 * Hosts the roleplay-scenario authoring section (catalog editor + org
 * roleplay flags + KB suggest). Re-homed out of the legacy `admin`
 * bucket per `docs/design/admin_split_and_entitlements.md` §5 + §7.1
 * and the four-product taxonomy in
 * `docs/products/_product_definitions_handoff.md` §7.1 (training
 * authoring → Turbo Sales / Manager bucket).
 */
export function TrainingAuthorPanel() {
  const scopedOrgId = useScopedOrganizationId();
  if (!scopedOrgId) {
    return (
      <div className={`${sectionCardClass} text-sm ${cardMutedTextClass}`}>
        Select a workspace organization first to author training scenarios.
      </div>
    );
  }
  return (
    <div {...{ [FIREFLY_TARGET_ATTR]: "ta-surface" }} className="space-y-4">
      <header>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">Training Authoring</h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
          Author roleplay scenarios, tune manufacturer-inherited content, and pull drafts from the knowledge base. Reps practice these scenarios from the Sales bucket&apos;s Training → Roleplay tab.
        </p>
      </header>
      <RoleplayTrainingSection organizationId={scopedOrgId} />
    </div>
  );
}
